import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { Avatar, Box, Checkbox, Float, HStack, IconButton, Table, Text, Wrap } from '@chakra-ui/react';
import { Tooltip } from '@src/components/chakra-ui/tooltip';
import { useInvestorSearchContext } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchContext';
import { CheckIcon } from '@src/components/sco/icons';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoInvestorProfile } from '@src/graphql-types';
import { renderCurrency } from '@src/lib/adminUtils';
import { gql } from '@src/lib/gql';
import { uniq, uniqBy } from 'lodash';
import React from 'react';
import { MdOpenInNew } from 'react-icons/md';
import { PiHeart, PiHeartFill } from 'react-icons/pi';
type InvestorResultRowProps = {
  investor: ScoInvestorProfile;
  isChecked?: boolean;
  isSelected?: boolean;
  onCheckedChange?: (investorProfileId: string, isChecked: boolean) => any;
  onSelect?: (investorProfileId: string) => any;
};
export const InvestorResultRow = props => {
  const $ = _c(128);
  const {
    filterValues
  } = useInvestorSearchContext();
  const {
    investor
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    mutation ($input: ToggleInvestorProfileUserSaveInput!) {
      toggleInvestorProfileUserSave(input: $input) {
        investorProfile {
          id
          investorProfileId
          currentUserHasSaved
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [toggleInvestorProfileUserSave] = useMutation(t0);
  let T0;
  let T1;
  let T2;
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== filterValues.investmentStages || $[2] !== filterValues.preferredIndustries || $[3] !== filterValues.preferredIndustriesAndVerticals || $[4] !== filterValues.preferredVerticals || $[5] !== investor.currentUserHasSaved || $[6] !== investor.hqLocation || $[7] !== investor.investmentStages || $[8] !== investor.investorProfileId || $[9] !== investor.isVerified || $[10] !== investor.logoUrl || $[11] !== investor.maximumDealSizeInDollars || $[12] !== investor.maximumInvestmentInDollars || $[13] !== investor.minimumDealSizeInDollars || $[14] !== investor.minimumInvestmentInDollars || $[15] !== investor.preferredIndustries || $[16] !== investor.preferredVerticals || $[17] !== investor.primaryInvestorType || $[18] !== investor.title || $[19] !== props || $[20] !== toggleInvestorProfileUserSave) {
    const activeTags = [...(filterValues.preferredIndustries || []), ...(filterValues.preferredVerticals || []), ...(filterValues.preferredIndustriesAndVerticals || []), ...(filterValues.investmentStages || [])];
    const parsedMinimum = parseFloat(`${investor.minimumInvestmentInDollars || investor.minimumDealSizeInDollars}`);
    const parsedMaximum = parseFloat(`${investor.maximumInvestmentInDollars || investor.maximumDealSizeInDollars}`);
    T2 = Table.Row;
    t5 = "pointer";
    const t12 = props.isSelected ? "colorPalette.emphasized" : props.isChecked ? "colorPalette.emphasized" : "colorPalette.muted/20";
    if ($[35] !== t12) {
      t6 = {
        bgColor: t12
      };
      $[35] = t12;
      $[36] = t6;
    } else {
      t6 = $[36];
    }
    t7 = props.isSelected ? "colorPalette.container" : props.isChecked ? "colorPalette.emphasized/50" : null;
    let t13;
    if ($[37] !== investor.investorProfileId || $[38] !== props) {
      t13 = details => {
        props.onCheckedChange?.(investor.investorProfileId, details.checked === true);
      };
      $[37] = investor.investorProfileId;
      $[38] = props;
      $[39] = t13;
    } else {
      t13 = $[39];
    }
    let t14;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Checkbox.HiddenInput />;
      $[40] = t14;
    } else {
      t14 = $[40];
    }
    let t15;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <Checkbox.Control><Checkbox.Indicator /></Checkbox.Control>;
      $[41] = t15;
    } else {
      t15 = $[41];
    }
    let t16;
    if ($[42] !== props.isChecked || $[43] !== t13) {
      t16 = <Checkbox.Root checked={props.isChecked} marginRight="0.5em" onClick={_temp} onCheckedChange={t13}>{t14}{t15}</Checkbox.Root>;
      $[42] = props.isChecked;
      $[43] = t13;
      $[44] = t16;
    } else {
      t16 = $[44];
    }
    let t17;
    if ($[45] !== investor.investorProfileId || $[46] !== toggleInvestorProfileUserSave) {
      t17 = ev_0 => {
        ev_0.stopPropagation();
        toggleInvestorProfileUserSave({
          variables: {
            input: {
              investorProfileId: investor.investorProfileId
            }
          }
        });
      };
      $[45] = investor.investorProfileId;
      $[46] = toggleInvestorProfileUserSave;
      $[47] = t17;
    } else {
      t17 = $[47];
    }
    let t18;
    if ($[48] !== investor.currentUserHasSaved) {
      t18 = investor.currentUserHasSaved ? <PiHeartFill /> : <PiHeart />;
      $[48] = investor.currentUserHasSaved;
      $[49] = t18;
    } else {
      t18 = $[49];
    }
    let t19;
    if ($[50] !== t17 || $[51] !== t18) {
      t19 = <IconButton aria-label="Save" size="sm" variant="ghost" onClick={t17}>{t18}</IconButton>;
      $[50] = t17;
      $[51] = t18;
      $[52] = t19;
    } else {
      t19 = $[52];
    }
    const t20 = `/investors/${investor.investorProfileId}`;
    let t21;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <MdOpenInNew />;
      $[53] = t21;
    } else {
      t21 = $[53];
    }
    let t22;
    if ($[54] !== t20) {
      t22 = <IconButton asChild={true} aria-label="Open Profile" size="sm" variant="ghost"><NextLink href={t20} target="_blank">{t21}</NextLink></IconButton>;
      $[54] = t20;
      $[55] = t22;
    } else {
      t22 = $[55];
    }
    if ($[56] !== t16 || $[57] !== t19 || $[58] !== t22) {
      t8 = <Table.Cell paddingRight={0}><HStack align="center" gap={0} justify="center">{t16}{t19}{t22}</HStack></Table.Cell>;
      $[56] = t16;
      $[57] = t19;
      $[58] = t22;
      $[59] = t8;
    } else {
      t8 = $[59];
    }
    let t23;
    if ($[60] !== investor.investorProfileId || $[61] !== props) {
      t23 = () => props.onSelect(investor.investorProfileId);
      $[60] = investor.investorProfileId;
      $[61] = props;
      $[62] = t23;
    } else {
      t23 = $[62];
    }
    const t24 = investor.logoUrl ? "whiteAlpha.500" : "";
    let t25;
    if ($[63] !== investor.title) {
      t25 = <Avatar.Fallback borderRadius="sm" name={investor.title} />;
      $[63] = investor.title;
      $[64] = t25;
    } else {
      t25 = $[64];
    }
    let t26;
    if ($[65] !== investor.logoUrl) {
      t26 = <Avatar.Image borderRadius="sm" src={investor.logoUrl} />;
      $[65] = investor.logoUrl;
      $[66] = t26;
    } else {
      t26 = $[66];
    }
    let t27;
    if ($[67] !== investor.isVerified) {
      t27 = investor.isVerified && <Float offsetX="1" offsetY="1" placement="bottom-end"><Tooltip content="Verified" showArrow={true}><Box alignItems="center" bgColor="green" borderRadius="full" boxSize="1em" display="flex" justifyContent="center"><CheckIcon width="0.5em" /></Box></Tooltip></Float>;
      $[67] = investor.isVerified;
      $[68] = t27;
    } else {
      t27 = $[68];
    }
    let t28;
    if ($[69] !== t24 || $[70] !== t25 || $[71] !== t26 || $[72] !== t27) {
      t28 = <Avatar.Root bgColor={t24} borderRadius="sm" size="md">{t25}{t26}{t27}</Avatar.Root>;
      $[69] = t24;
      $[70] = t25;
      $[71] = t26;
      $[72] = t27;
      $[73] = t28;
    } else {
      t28 = $[73];
    }
    let t29;
    if ($[74] !== investor.title) {
      t29 = <Text color="colorPalette.fg" fontWeight="semibold" textStyle="md">{investor.title}</Text>;
      $[74] = investor.title;
      $[75] = t29;
    } else {
      t29 = $[75];
    }
    let t30;
    if ($[76] !== investor.primaryInvestorType) {
      t30 = <Text color="colorPalette.fg/50" fontWeight="medium" lineHeight={1} marginY={0} textStyle="sm">{investor.primaryInvestorType}</Text>;
      $[76] = investor.primaryInvestorType;
      $[77] = t30;
    } else {
      t30 = $[77];
    }
    let t31;
    if ($[78] !== t29 || $[79] !== t30) {
      t31 = <Box flexGrow={1}>{t29}{t30}</Box>;
      $[78] = t29;
      $[79] = t30;
      $[80] = t31;
    } else {
      t31 = $[80];
    }
    let t32;
    if ($[81] !== t28 || $[82] !== t31) {
      t32 = <HStack gap={4}>{t28}{t31}</HStack>;
      $[81] = t28;
      $[82] = t31;
      $[83] = t32;
    } else {
      t32 = $[83];
    }
    if ($[84] !== t23 || $[85] !== t32) {
      t9 = <Table.Cell onClick={t23}>{t32}</Table.Cell>;
      $[84] = t23;
      $[85] = t32;
      $[86] = t9;
    } else {
      t9 = $[86];
    }
    let t33;
    if ($[87] !== investor.investorProfileId || $[88] !== props) {
      t33 = () => props.onSelect(investor.investorProfileId);
      $[87] = investor.investorProfileId;
      $[88] = props;
      $[89] = t33;
    } else {
      t33 = $[89];
    }
    let t34;
    if ($[90] !== investor.hqLocation) {
      t34 = investor.hqLocation && uniq(investor.hqLocation.split(",").filter(Boolean).reverse()).map(_temp2);
      $[90] = investor.hqLocation;
      $[91] = t34;
    } else {
      t34 = $[91];
    }
    if ($[92] !== t33 || $[93] !== t34) {
      t10 = <Table.Cell onClick={t33}>{t34}</Table.Cell>;
      $[92] = t33;
      $[93] = t34;
      $[94] = t10;
    } else {
      t10 = $[94];
    }
    let t35;
    if ($[95] !== investor.investorProfileId || $[96] !== props) {
      t35 = () => props.onSelect(investor.investorProfileId);
      $[95] = investor.investorProfileId;
      $[96] = props;
      $[97] = t35;
    } else {
      t35 = $[97];
    }
    let t36;
    if ($[98] !== parsedMinimum) {
      t36 = !isNaN(parsedMinimum) && parsedMinimum > 0 ? renderCurrency(parsedMinimum * 100, true, false, 0) : "0";
      $[98] = parsedMinimum;
      $[99] = t36;
    } else {
      t36 = $[99];
    }
    let t37;
    if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
      t37 = <Text color="colorPalette.fg/70">{" to "}</Text>;
      $[100] = t37;
    } else {
      t37 = $[100];
    }
    let t38;
    if ($[101] !== parsedMaximum) {
      t38 = !isNaN(parsedMaximum) && parsedMaximum > 0 ? renderCurrency(parsedMaximum * 100, true, false, 0) : "++";
      $[101] = parsedMaximum;
      $[102] = t38;
    } else {
      t38 = $[102];
    }
    let t39;
    if ($[103] !== t36 || $[104] !== t38) {
      t39 = <HStack fontWeight="medium" gap={1.5} paddingBottom="2px" textStyle="sm">{t36}{t37}{t38}</HStack>;
      $[103] = t36;
      $[104] = t38;
      $[105] = t39;
    } else {
      t39 = $[105];
    }
    t11 = <Table.Cell onClick={t35}>{t39}<Wrap gap="0.25em" width="full">{uniqBy(investor.investmentStages, _temp3).filter(Boolean).sort().map((label, idx_0) => <Text key={idx_0} borderRadius="sm" color="colorPalette.fg" display="inline-block" fontSize="xs" fontWeight={activeTags.includes(label) ? "semibold" : "normal"} lineHeight="shorter" padding="0.25em 0.5em" bgColor={activeTags.find(tag => label.toLowerCase().includes(tag.toLowerCase())) ? "colorPalette.focusRing" : "colorPalette.muted/50"}>{label}</Text>)}</Wrap></Table.Cell>;
    T1 = Table.Cell;
    if ($[106] !== investor.investorProfileId || $[107] !== props) {
      t4 = () => props.onSelect(investor.investorProfileId);
      $[106] = investor.investorProfileId;
      $[107] = props;
      $[108] = t4;
    } else {
      t4 = $[108];
    }
    T0 = Wrap;
    t1 = "0.25em";
    t2 = "full";
    t3 = uniqBy([...investor.preferredIndustries, ...investor.preferredVerticals], _temp4).filter(Boolean).sort().map((label_0, idx_1) => <Text key={idx_1} borderRadius="sm" color="colorPalette.fg" display="inline-block" fontSize="xs" fontWeight={activeTags.includes(label_0) ? "semibold" : "normal"} lineHeight="shorter" padding="0.25em 0.5em" bgColor={activeTags.find(tag_0 => label_0.toLowerCase().includes(tag_0.toLowerCase())) ? "colorPalette.focusRing" : "colorPalette.muted/50"}>{label_0}</Text>);
    $[1] = filterValues.investmentStages;
    $[2] = filterValues.preferredIndustries;
    $[3] = filterValues.preferredIndustriesAndVerticals;
    $[4] = filterValues.preferredVerticals;
    $[5] = investor.currentUserHasSaved;
    $[6] = investor.hqLocation;
    $[7] = investor.investmentStages;
    $[8] = investor.investorProfileId;
    $[9] = investor.isVerified;
    $[10] = investor.logoUrl;
    $[11] = investor.maximumDealSizeInDollars;
    $[12] = investor.maximumInvestmentInDollars;
    $[13] = investor.minimumDealSizeInDollars;
    $[14] = investor.minimumInvestmentInDollars;
    $[15] = investor.preferredIndustries;
    $[16] = investor.preferredVerticals;
    $[17] = investor.primaryInvestorType;
    $[18] = investor.title;
    $[19] = props;
    $[20] = toggleInvestorProfileUserSave;
    $[21] = T0;
    $[22] = T1;
    $[23] = T2;
    $[24] = t1;
    $[25] = t10;
    $[26] = t11;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    T0 = $[21];
    T1 = $[22];
    T2 = $[23];
    t1 = $[24];
    t10 = $[25];
    t11 = $[26];
    t2 = $[27];
    t3 = $[28];
    t4 = $[29];
    t5 = $[30];
    t6 = $[31];
    t7 = $[32];
    t8 = $[33];
    t9 = $[34];
  }
  let t12;
  if ($[109] !== T0 || $[110] !== t1 || $[111] !== t2 || $[112] !== t3) {
    t12 = <T0 gap={t1} width={t2}>{t3}</T0>;
    $[109] = T0;
    $[110] = t1;
    $[111] = t2;
    $[112] = t3;
    $[113] = t12;
  } else {
    t12 = $[113];
  }
  let t13;
  if ($[114] !== T1 || $[115] !== t12 || $[116] !== t4) {
    t13 = <T1 onClick={t4}>{t12}</T1>;
    $[114] = T1;
    $[115] = t12;
    $[116] = t4;
    $[117] = t13;
  } else {
    t13 = $[117];
  }
  let t14;
  if ($[118] !== T2 || $[119] !== t10 || $[120] !== t11 || $[121] !== t13 || $[122] !== t5 || $[123] !== t6 || $[124] !== t7 || $[125] !== t8 || $[126] !== t9) {
    t14 = <T2 cursor={t5} _hover={t6} bgColor={t7}>{t8}{t9}{t10}{t11}{t13}</T2>;
    $[118] = T2;
    $[119] = t10;
    $[120] = t11;
    $[121] = t13;
    $[122] = t5;
    $[123] = t6;
    $[124] = t7;
    $[125] = t8;
    $[126] = t9;
    $[127] = t14;
  } else {
    t14 = $[127];
  }
  return t14;
};
function _temp(ev) {
  return ev.stopPropagation();
}
function _temp2(part, idx) {
  return <Text key={idx} fontWeight="medium" textStyle="sm">{part.trim()}</Text>;
}
function _temp3(x) {
  return x.toLowerCase();
}
function _temp4(x_0) {
  return x_0.toLowerCase();
}